import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../modules'
import {util} from '../libs'

Vue.use(VueRouter)

const routers = [
  {path: '/', meta: {title: '首页'}, redirect: '/custom/center'},
  {
    path: '/aic/reg',
    meta: {title: '重定向'},
    component: (resolve) => require(['../views/samr/haikou.vue'], resolve)
  },
  {
    path: '/frame/login',
    meta: {title: '用户中心登陆'},
    component: (resolve) => require(['../views/frame/login.vue'], resolve)
  },
  {
    path: '/frame/404',
    meta: {title: '页面丢失'},
    component: (resolve) => require(['../views/frame/404.vue'], resolve)
  },
  {
    path: '/samr/samr-not-sync',
    meta: {title: '页面丢失'},
    component: (resolve) => require(['../views/samr/samr-not-sync.vue'], resolve)
  }
]

// 路由配置
const router = new VueRouter({mode: 'hash', routes: routers})

store.state.main.configPromise = store.dispatch('main/getSiteSetupFront').then(() => util.title(store.state.main.config.baseJson.title))

router.beforeEach((to, from, next) => {

  // 根据前缀判断需要登录才能执行
  if (to.path.startsWith('/custom/')) {
    if (store.state.custom.user && (!to.query.token || (to.query.token === store.state.custom.user.token))) {
      next()
      return
    }

    let token = to.query.token || store.state.custom.token

    if (token) {
      store.dispatch('custom/loginByToken', token).then(() => store.state.main.configPromise).then(() => {
        router.addRoutes(store.state.custom.routers)
        next({path: to.path, query: to.query, params: to.params})
      }, () => {
        next({path: '/frame/login', query: {redirect: to.fullPath}})
      })
    } else {
      next({path: '/frame/login', query: {redirect: to.fullPath}})
    }
  } else {
    next()
  }
})

router.afterEach((to) => {
  window.scrollTo(0, 0)
  store.commit('main/SET_CLEAR_INTERVAL')

  if (to.matched.length > 0) {
    store.commit('main/SET_BREADCRUMB_DATA', to)
  } else {
    router.push({path: '/frame/404'})
  }
})

export default router
